import img1 from '../images/item/item-01.png';
import img2 from '../images/item/item-02.png';
import img3 from '../images/item/item-03.png';
import img4 from '../images/item/item-04.png';
import img5 from '../images/item/item-05.png';
import img6 from '../images/item/item-06.png';
import img7 from '../images/item/item-07.png';
import img8 from '../images/item/item-08.png';

const dataItem = [

  {
    id: 1,
    img: img8,
    title: 'Exclusive Pool Party',
    owner: 'DJ BOOM, DJ ROMPEBOCINA, DISQOBRAT',
    venue: 'Private Resort',
    date: 'Sat, Sep 27 • 12PM',
    likes: 4112,
    labelCaption: 'Invite Only',
    label: 'Request Invite',
    // Example of a true external (kept as full URL)
    rsvpUrl: 'https://posh.vip/e/4th-annual-pool-party'
  }
];

export default dataItem;